import { dateToStr, addDays, subDays } from "../helpers/date-helper.js";
import axiosV2 from "../core/http/axios_api_v2"
import { mapCalendarItems, mapEvents, mapGoogleEvents, mapMeetings, mapQuotes, mapTasks, mapHolds, mapPersonalItems } from '../services/calendar/item-mapper'
import '../services/calendar/holds.css'

export default {




    //coooooool!
    cache: {},



    hardResetAllCalendars(){

        this.cache = {};
        this.currentMonthPromise = null;
        this.activeCalendarComonents.map(calendar => calendar.updateItems(calendar.dateToShow));
        

    },


    activeCalendarComonents: [],


    // Online-booking availability per shown range. Several calendars live on one page (the page
    // calendar, the header quick calendar...) and all ask for the same range — one request serves
    // them all. Invalidated whenever a date's availability is saved.
    bookingAvailabilityCache: {},

    getBookingAvailability(fromKey, toKey) {

        const cacheKey = `${fromKey}|${toKey}`;

        if (this.bookingAvailabilityCache[cacheKey])
            return this.bookingAvailabilityCache[cacheKey];

        this.bookingAvailabilityCache[cacheKey] = axiosV2(`booking/day-availability?from=${fromKey}&to=${toKey}`)
            .then(response => response.data)
            .catch(() => {
                // 403 = the account has no online booking; don't keep a failure cached
                delete this.bookingAvailabilityCache[cacheKey];
                return null;
            });

        return this.bookingAvailabilityCache[cacheKey];
    },

    resetBookingAvailability() {
        this.bookingAvailabilityCache = {};
    },


    registerCalendarComponent(calendarComponent){
        this.activeCalendarComonents.push(calendarComponent);
    },


    addItemToCache(itemDate,itemType,itemData){

        //hard reset because of all the maybe events we could have
        if (itemType=='event'){
            this.hardResetAllCalendars();
            return;
        }


        if (!itemDate)
            return;

        if (typeof itemDate == 'string')
            itemDate = new Date(itemDate);

        let itemForCalendar;
        let cacheKeyForNewItem = this.buildCacheKey(itemDate);

        //if this key is not even cached we have nothing to do
        if (!this.cache[cacheKeyForNewItem])
            return;

        


        //transforming from native item to calendar item
        switch (itemType){
            case 'task':
                itemForCalendar = mapTasks(itemData)
                break;
            case 'meeting':
                itemForCalendar = mapMeetings(itemData)
                break;

            // אישי: the row the api returned on save (PersonalItemModal)
            case 'personal':
                itemForCalendar = mapPersonalItems(itemData)
                break;

            // case 'event': //event doesnt happen here because of hard reset
                // itemForCalendar = mapEvents(itemData)
                // break;

                
                
        }

        
        if (!itemForCalendar)
            return;

        //checking if already exists, and removing:
        let existingIndex = this.cache[cacheKeyForNewItem].findIndex(item => item.id == itemForCalendar.id);
        if (existingIndex != -1){   //because it can be 0
            this.cache[cacheKeyForNewItem].splice(existingIndex,1);
        }

        //adding item to cache
        this.cache[cacheKeyForNewItem].push(itemForCalendar);
        
        //getting list of calendars to update
        let calendarsToUpdate = this.getCalendarsCurrentlyShowingThisKey(cacheKeyForNewItem);

        //doing the actual updates
        calendarsToUpdate.map(calendar => calendar.updateItems(calendar.dateToShow));


    },


    // an item deleted (אישי): out of every cached month that holds it, and the calendars redraw
    removeItemFromCache(itemId){

        Object.keys(this.cache).forEach(cacheKey => {
            const items = this.cache[cacheKey];
            const index = items ? items.findIndex(item => item.id == itemId) : -1;
            if (index != -1)
                items.splice(index, 1);
        });

        this.activeCalendarComonents.map(calendar => calendar.updateItems(calendar.dateToShow));
    },


    getCalendarsCurrentlyShowingThisKey(cacheKey){

        let calendarsToUpdate = [];

        for (let i=0; i<this.activeCalendarComonents.length; i++){

            if (this.activeCalendarComonents[i].currentCacheKey == cacheKey)

                calendarsToUpdate.push(this.activeCalendarComonents[i]);
            
        }

        return calendarsToUpdate;

    },



    //on load we might have 2 calendars initiating and wanting to pull todays data at same time
    currentMonthPromise: null, 




    addToCache(key,value){
        this.cache[key] = value;
    },

    getFromCache(key){
        return this.cache[key];
    },


    thisIsTheCacheKeyForCurrentMonth(cacheKey){

        return cacheKey == this.buildCacheKey(new Date())

    },

    buildCacheKey(d){
        const utc = new Date(d.toISOString())
        const start_date = this.getMonthStartDate(utc);
        const end_date = this.getMonthEndDate(utc);
        return `${start_date} - ${end_date}`;
    },


    getMonthStartDate(utc){
        return dateToStr(subDays(utc, utc.getDate() + 7), 'yyyy-mm-dd')
    },
    getMonthEndDate(utc){
        return dateToStr(addDays(utc, 31 - utc.getDate() + 7), 'yyyy-mm-dd')
    },


    //we play here with +7 to show also the weeks before and after. it works well
    getItemsInMonth(d) {    

        const utc = new Date(d.toISOString())
        const start_date = this.getMonthStartDate(utc);
        const end_date = this.getMonthEndDate(utc);
        const cacheKey = this.buildCacheKey(d);


        //check if we already promised current month data
        if (this.thisIsTheCacheKeyForCurrentMonth(cacheKey) && this.currentMonthPromise)
            return this.currentMonthPromise;


        //check if we have this month in cache, we return a promise because callers of this function expect a promise
        if (this.getFromCache(cacheKey)){
            console.log(`Calendar cache hit: ${cacheKey}`);
            return new Promise((resolve)=>resolve(this.getFromCache(cacheKey)));
        }
            

        console.log(`Requesting calendar from server: ${start_date} - ${end_date}`);

        let axiosPromise = axiosV2(`calendar?start_date=${start_date}&end_date=${end_date}`).then((response) => {

            let items = [
                
                ...response.data.meetings.map(mapMeetings),
                ...response.data.tasks.map(mapTasks),
                ...response.data.googleEvents.map(mapGoogleEvents),
                ...response.data.events.map(mapEvents),
                // שריוני תאריך: the optional dates of undated events (item type 'hold')
                ...(response.data.holds || []).map(mapHolds),
                // אישי: מילואים / רופא... (item type 'personal')
                ...(response.data.personalItems || []).map(mapPersonalItems),
            ];

            this.addToCache(cacheKey,items);

            return items;
        })


        if (this.thisIsTheCacheKeyForCurrentMonth(cacheKey))
            this.currentMonthPromise = axiosPromise;


        return axiosPromise;
    }






}